import styled from "styled-components";

export const StyledDrinkList = styled.ul`
  max-width: 1200px;
  width: 100%;

  padding: 1rem;
`;
